'use strict';

var _promise = require('babel-runtime/core-js/promise');
var _promise2 = _interopRequireDefault(_promise);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RestPaginator = void 0;
/**
 * @class Paginator
 * @classdesc Pagination helper class
 *
 * @property {Array} items Array of elements on current page
 * @property {boolean} hasNextPage Indicates the existence of next page
 * @property {boolean} hasPrevPage Indicates the existence of previous page
 */

var RestPaginator = function () {
  /*
  * @constructor
  * @param {Array} items Array of element for current page
  * @param {Object} params
  * @private
  */
  function RestPaginator(items, source, prevToken, nextToken) {
    (0, _classCallCheck3.default)(this, RestPaginator);
    this.state = {
      prevToken: prevToken,
      nextToken: nextToken,
      source: source,
      items: items
    };
  }
  (0, _createClass3.default)(RestPaginator, [{
    key: 'nextPage',
    value: function nextPage() {
      return this.hasNextPage ? this.state.source(this.state.nextToken) : _promise2.default.reject(new Error('No next page'));
    }
  }, {
    key: 'prevPage',
    value: function prevPage() {
      return this.hasPrevPage ? this.state.source(this.state.prevToken) : _promise2.default.reject(new Error('No previous page'));
    }
  }, {
    key: 'hasNextPage',
    get: function get() {
      return !!this.state.nextToken;
    }
  }, {
    key: 'hasPrevPage',
    get: function get() {
      return !!this.state.prevToken;
    }
  }, {
    key: 'items',
    get: function get() {
      return this.state.items;
    }
  }]);
  return RestPaginator;
}();
exports.RestPaginator = RestPaginator;